import { Card, CardContent } from "@repo/ui";

export default function Gallery() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-semibold tracking-tight mb-6">Gallery</h1>
      <p className="text-muted-foreground mb-8">
        A glimpse of Mano Glamping and the lush Suan Pueng surroundings.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {[...Array(9)].map((_, i) => (
          <Card key={i} className="overflow-hidden">
            <CardContent className="p-0">
              <div className="aspect-square bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
